import { StaticImageData } from "next/image"

const resize = (image: StaticImageData): StaticImageData => {
	return { ...image, width: image.width / 3, height: image.height / 3 }
}

export default resize
